import { useSelector } from "react-redux";
import MainPageLayout from "../../../layout/MainPageLayout";

import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { EXPENSE_MONTHLY_GENERATED_SHEET } from "../../../api/allApi_List";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";
import GeneratedMonthlyList from "../components/GeneratedMonthlyList";

const GeneratedMonthlyPage = () => {
  const { isLoaded } = useFetchData(EXPENSE_MONTHLY_GENERATED_SHEET);
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;

  return (
    <MainPageLayout
      headerConfig={{ title: "Generated Monthly Sheet" }}
      numberOfData={dataLength}
      bgColor="bg-dBlue-100"
    >
      {isLoaded && !error ? (
        <GeneratedMonthlyList />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading..." animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default GeneratedMonthlyPage;
